import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ToastActions = createActionGroup({
  source: 'Toast Actions',
  events: {
    Error: props<{ message: string }>(),
    Success: props<{ message: string }>(),
    Warning: props<{ message: string }>(),
    'Clear All': emptyProps,
  },
});
